<header class="animate-header-enter animate-delay-1">
  <div class="top-header-bar bg-blue text-white animate-fade-down-soft">
    <div class="mx-auto flex md:px-12 px-2 justify-between">
      <div class="flex items-center text-sm gap-x-1 py-2">
        <sham-i-location-address />
        {{ 'Store Location' | translate }} {{ 'Damascus' | translate }},
        {{ 'Homs' | translate }}, {{ 'Aleppo' | translate }}
      </div>
      <div
        class="top-header-actions hidden sm:flex gap-x-3 items-center *:font-normal!"
      >
        <div class="dropdown dropdown-end">
          <!-- <button
            class="btn btn-ghost btn-xs btn-primary text-white"
            popovertarget="currency-popover"
            style="anchor-name: --currency-popover"
          >
            USD
            <sham-i-usa-flag />
          </button> -->
          <!-- <menu
            class="dropdown menu w-22 rounded-box bg-base-100 shadow-sm text-black"
            popover
            id="currency-popover"
            style="position-anchor: --currency-popover"
          >
            <li class="flex">
              <a
                >SYP <span> <sham-i-sy-flag /></span
              ></a>
            </li>
          </menu> -->
        </div>
        <language-switcher />
        <!-- <div class="dropdown dropdown-end flex justify-center items-center">
          <menu
            class="dropdown menu w-30 rounded-box bg-base-100 shadow-sm text-black"
            popover
            id="localization-popover"
            style="position-anchor: --localization-popover"
          >
            <li>
              <a>{{ 'Arabic' | translate }}</a>
            </li>
          </menu>
        </div> -->
        <hr class="vr border-white/50 border h-6" />
        @if (!auth.isLoggedIn()) {
          <div class="flex items-center h-full">
            <button
              routerLink="/auth/login"
              class="btn px-1 mx-1 btn-ghost rounded hover:shadow-none btn-xs lg:btn-sm border-0 btn-primary text-white"
            >
              {{ 'Sign In' | translate }}
            </button>
            <p>/</p>
            <button
              routerLink="/auth/register"
              class="btn px-1 mx-1 btn-ghost rounded hover:shadow-none btn-xs lg:btn-sm border-0 btn-primary text-white"
            >
              {{ 'Sign Up' | translate }}
            </button>
          </div>
        } @else {
          <div #accountMenuWrapper class="account-menu-wrapper dropdown dropdown-en">
            <!-- type="button" -->
            <button
              class="text-xs transition-all rounded px-1.5 py-0.5 hover:bg-blue-h hover:border-none text-white cursor-pointer flex items-center"
              [attr.aria-expanded]="accountMenuOpen()"
              (click)="toggleAccountMenu($event)"
              popovertarget="account-popover"
              style="anchor-name: --account-popover"
            >
              <span class="flex items-center gap-2">
                <div
                  class="size-4 overflow-hidden rounded-full border border-white-light bg-white-light-a"
                >
                  <img
                    *ngIf="profilePhotoUrl(); else accountInitials"
                    [src]="profilePhotoUrl()"
                    alt="avatar"
                    class="h-full w-full object-cover"
                  />
                  <ng-template #accountInitials>
                    <div
                      class="flex h-full w-full items-center justify-center text-3xs font-bold text-gray"
                    >
                      {{ getInitials(accountName()) }}
                    </div>
                  </ng-template>
                </div>
                <span>{{ accountName() || ('My Account' | translate) }}</span>
              </span>
              <sham-i-arrow-down-01-Stroke
                class="ml-1 transition-transform duration-200"
                [class.rotate-180]="accountMenuOpen()"
              />
            </button>

            <ul
              class="account-menu dropdown menu p-2 shadow-xl bg-white rounded-box w-52 text-xs text-black z-100"
              [class.account-menu-open]="accountMenuOpen()"
            >
              <li>
                <a
                  routerLink="/profile"
                  class="hover:bg-blue-light-h! hover:text-blue-a! flex items-center gap-2 px-2 py-2 rounded text-xs"
                  (click)="onAccountMenuAction()"
                >
                  <sham-i-Settings />
                  {{ 'Account Settings' | translate }}
                </a>
              </li>
              <li>
                <button
                  type="button"
                  (click)="logout()"
                  class="hover:bg-blue-light-h! hover:text-blue-a! flex items-center gap-2 px-2 py-2 rounded w-full text-xs"
                >
                  <sham-i-logout-01-Bulk />
                  {{ 'Log Out' | translate }}
                </button>
              </li>
            </ul>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="lower-header-bar">
    <div class="py-2 sm:py-4 mx-auto flex md:px-12 px-2 justify-between items-center">
      <div class="transition-transform duration-300 hover:scale-[1.02]">
        <a routerLink="/home">
          <sham-i-sham-logo-Full class="*:h-8 md:*:h-12" />
        </a>
      </div>

      <app-marketplace-search />

      <div class="flex gap-x-3 items-center bg-[#fff]">
        @if (auth.isLoggedIn()) {
          <div class="relative" (click)="$event.stopPropagation()">
            <button
              type="button"
              (click)="toggleNotifications($event)"
              class="relative transition-transform duration-200 hover:scale-105"
              [attr.aria-label]="'notifications.title' | translate"
              [attr.aria-expanded]="isNotificationsOpen()"
            >
              <sham-i-notification01 class="*:size-6 sm:*:size-7" />
              @if (unreadNotificationsCount()) {
                <span
                  class="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-[#EA738C] text-[#fff] text-2xs leading-4 text-center font-semibold"
                >
                  {{ unreadNotificationsCount() }}
                </span>
              }
            </button>

            @if (isNotificationsRendered()) {
              <div
                class="notification-dropdown absolute top-[calc(100%+14px)] end-0 z-40 w-[440px] max-w-[calc(100vw-1rem)] overflow-hidden rounded-lg border border-[#E2E8F0] bg-[#fff] shadow-[0_18px_48px_rgba(17,68,85,0.18)]"
                [class.notification-dropdown-open]="isNotificationsOpen()"
                [class.notification-dropdown-closed]="!isNotificationsOpen()"
              >
                <div class="flex items-center justify-between p-6">
                  <h3 class="text-xl font-semibold text-gray">
                    {{ 'notifications.title' | translate }}
                  </h3>
                  <button
                    type="button"
                    (click)="markAllNotificationsAsRead($event)"
                    class="text-sm font-medium text-[#2192BA] transition hover:text-[#176B88]"
                  >
                    {{ 'notifications.markAllAsRead' | translate }}
                  </button>
                </div>

                <div class="divide-y divide-[#EDF2F6]">
                  @if (isNotificationsLoading() && !notificationPreview().length) {
                    <div class="p-6 text-sm text-[#64748B]">
                      {{ notificationsLoadingLabel() }}
                    </div>
                  } @else if (!notificationPreview().length) {
                    <div class="p-6 text-sm text-[#64748B]">
                      {{ notificationsEmptyLabel() }}
                    </div>
                  } @else {
                    @for (
                      notification of notificationPreview();
                      track notification.id
                    ) {
                      <article
                        class="relative flex cursor-pointer items-center gap-3 p-6"
                        [class.bg-[#EFF7FC]]="!notification.isRead"
                        (click)="openNotification(notification, $event)"
                      >
                        <div
                          class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#F0F9FF]"
                          [class.bg-[#fff]]="!notification.isRead"
                        >
                          @switch (notification.tone) {
                            @case ('coupon') {
                              <svg
                                class="h-6 w-6 text-[#5A9BC0]"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                              >
                                <path
                                  d="M8 7.5h8.5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0 5H8a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 0 0-5Z"
                                />
                                <path d="M10 7.5v10" stroke-dasharray="2 2" />
                                <circle
                                  cx="15.5"
                                  cy="10"
                                  r="1"
                                  fill="currentColor"
                                  stroke="none"
                                />
                                <circle
                                  cx="13"
                                  cy="15"
                                  r="1"
                                  fill="currentColor"
                                  stroke="none"
                                />
                              </svg>
                            }
                            @case ('gift') {
                              <svg
                                class="h-6 w-6 text-[#5A9BC0]"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                              >
                                <path
                                  d="M4 10.5h16v8a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-8Z"
                                />
                                <path d="M12 10.5V20" />
                                <path
                                  d="M4 10.5h16V7.8A1.8 1.8 0 0 0 18.2 6H5.8A1.8 1.8 0 0 0 4 7.8v2.7Z"
                                />
                                <path
                                  d="M12 6c-.8-1.9-3.6-2.8-4.8-1.3-.7.9-.4 2.3.7 3 .8.5 1.8.8 4.1 2.8"
                                />
                                <path
                                  d="M12 6c.8-1.9 3.6-2.8 4.8-1.3.7.9.4 2.3-.7 3-.8.5-1.8.8-4.1 2.8"
                                />
                              </svg>
                            }
                            @case ('delivery') {
                              <svg
                                class="h-6 w-6 text-[#5A9BC0]"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                              >
                                <path d="M3 7h10v8H3z" />
                                <path d="M13 10h3.5l2.5 2.8V15H13z" />
                                <circle cx="7" cy="17" r="1.7" />
                                <circle cx="17" cy="17" r="1.7" />
                                <path d="M5 9h3" />
                                <path d="M5 11h5" />
                              </svg>
                            }
                            @default {
                              <svg
                                class="h-6 w-6 text-[#5A9BC0]"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                              >
                                <path
                                  d="M12 3 5 6.2v5.1c0 4.2 2.7 8.2 7 9.7 4.3-1.5 7-5.5 7-9.7V6.2L12 3Z"
                                />
                                <path d="M9.5 11.5 11 13l3.5-3.5" />
                              </svg>
                            }
                          }
                        </div>

                        <div class="min-w-0 flex-1">
                          <p class="text-sm leading-5 text-[#171717]">
                            <span class="font-semibold">
                              {{ notification.title }}
                            </span>
                            {{ ' ' }}
                            {{ notification.body }}
                          </p>
                        </div>

                        <div
                          class="notification-actions relative shrink-0 self-start"
                        >
                          <button
                            type="button"
                            class="flex size-8 items-center justify-center rounded-full text-[#64748B] transition-colors hover:bg-[#E2E8F0] hover:text-[#171717] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#2192BA]"
                            [attr.aria-label]="
                              'Notification actions for ' + notification.title
                            "
                            [attr.aria-expanded]="
                              notificationActionsOpenFor() === notification.id
                            "
                            (click)="
                              toggleNotificationActions(notification.id, $event)
                            "
                          >
                            <sham-i-more-vertical class="*:size-5" />
                          </button>

                          <div
                            class="notification-actions-menu absolute end-0 top-[calc(100%+4px)] z-10 w-30 rounded-lg bg-white-light py-1 text-xs shadow-[0_8px_24px_rgba(17,68,85,0.18)]"
                            [class.notification-actions-menu-open]="
                              notificationActionsOpenFor() === notification.id
                            "
                            [class.notification-actions-menu-closed]="
                              notificationActionsOpenFor() !== notification.id
                            "
                          >
                            <button
                              type="button"
                              class="w-full px-4 py-2 text-start text-[#334155] transition-colors hover:bg-[#F1F5F9] focus-visible:bg-[#F1F5F9] focus-visible:outline-none"
                              (click)="
                                runNotificationAction(
                                  'markUnread',
                                  notification.id,
                                  $event
                                )
                              "
                            >
                              Mark as Unread
                            </button>
                            <button
                              type="button"
                              class="w-full px-4 py-2 text-start text-[#334155] transition-colors hover:bg-[#F1F5F9] focus-visible:bg-[#F1F5F9] focus-visible:outline-none"
                              (click)="
                                runNotificationAction(
                                  'archive',
                                  notification.id,
                                  $event
                                )
                              "
                            >
                              Archive
                            </button>
                            <button
                              type="button"
                              class="w-full px-4 py-2 text-start text-[#334155] transition-colors hover:bg-[#F1F5F9] focus-visible:bg-[#F1F5F9] focus-visible:outline-none"
                              (click)="
                                runNotificationAction(
                                  'delete',
                                  notification.id,
                                  $event
                                )
                              "
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      </article>
                    }
                  }
                </div>

                <div class="border-t border-[#E2E8F0] px-4 py-6 text-end">
                  <button
                    type="button"
                    (click)="goToNotifications($event)"
                    class="text-sm font-semibold text-[#2192BA] transition hover:text-[#176B88]"
                  >
                    {{ 'View All' | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
          <hr class="h-8 self-stretch border border-gray-200" />
        }
        <a>
          <sham-i-favourite01
            routerLink="/wishlist"
            class="*:size-6 sm:*:size-7 hover:*:fill-errortransition-all duration-300 hover:scale-110 active:scale-95 cursor-pointer"
          />
        </a>
        <hr class="h-8 self-stretch border border-gray-200" />
        <div class="flex gap-x-2 items-center">
          <a
            routerLink="/cart"
            class="relative transition-transform duration-200 hover:scale-105"
          >
            <sham-i-bag01
              class="*:size-6 sm:*:size-7 mb-1"
              [attr.aria-label]="'Shopping cart' | translate"
            />
            <span
              [ngClass]="{ hidden: cartItemsCount() === 0 }"
              class="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-[#EA738C] text-white cursor-pointer text-2xs leading-4 text-center font-semibold transition-transform duration-300 group-hover:rotate-12"
              aria-hidden="true"
            >
              {{ cartItemsCount() }}
            </span>
          </a>
          <dl>
            <dt class="text-xs text-[#4D4D4D]">
              {{ 'Shopping Cart:' | translate }}
            </dt>
            <dd class="font-medium">SYP {{ cartTotal() }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</header>
<div class="relative">
  <nav
    class="bg-white-h/25 text-gray font-medium text-4xs sm:text-sm text-nowrap overflow-x-auto"
  >
    <ul
      class="md:px-12 px-2 w-full mx-auto *:grow text-center [&_a]:p-2 sm:[&_a]:py-3 sm:[&_a]:px-4 **:block flex justify-between [&_a]:hover:bg-blue-light-h [&_a]:hover:text-blue-a [&_a]:transition-colors [&_a]:duration-200"
    >
      <li class="nav-animate nav-delay-1">
        <a
          routerLink="/home"
          routerLinkActive="bg-blue-a! text-white!"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ 'Home' | translate }}
        </a>
      </li>
      <li class="nav-animate nav-delay-2">
        <a
          routerLinkActive="bg-blue-a! text-white!"
          (click)="handleAllCategoriesClick($event)"
          [class.bg-blue-a]="isMegaMenuOpen()"
          [class.text-white]="isMegaMenuOpen()"
          class="cursor-pointer"
        >
          {{ 'All Categories' | translate }}
        </a>
      </li>
      <!-- <li class="nav-animate nav-delay-3">
        <a routerLink="/deals" routerLinkActive="bg-blue-a! text-white!">
          {{ "Today's Deals" | translate }}
        </a>
      </li> -->
      <li class="nav-animate nav-delay-4">
        <a routerLinkActive="bg-blue-a! text-white!" [href]="sellerDashboardUrl">
          {{ 'Become a Seller' | translate }}
        </a>
      </li>
      <!-- <li class="nav-animate nav-delay-5">
        <a routerLink="/customer-service" routerLinkActive="bg-blue-a! text-white!">
          {{ 'Customer Service' | translate }}
        </a>
      </li> -->
      <li class="nav-animate nav-delay-6">
        <a routerLink="/about-us" routerLinkActive="bg-blue-a! text-white!">
          {{ 'About Us' | translate }}
        </a>
      </li>
      <li class="nav-animate nav-delay-7">
        <a routerLink="/contact-us" routerLinkActive="bg-blue-a! text-white!">
          {{ 'Contact Us' | translate }}
        </a>
      </li>
    </ul>
  </nav>
  @if (isMegaMenuOpen()) {
    <div
      class="hidden lg:block absolute top-full left-0 right-0 z-20 bg-white shadow-lg border-t border-gray-200 text-nowrap **:min-w-fit animate-mega-menu"
    >
      <div class="md:px-12 px-2 mx-auto flex gap-6 py-6">
        <!-- Left sidebar with category list -->
        <div class="border-r border-gray-200">
          <ul class="space-y-1">
            @for (category of categoriesData(); track category.slug) {
              <li>
                <a
                  [routerLink]="['/categories', category.slug]"
                  (mouseover)="setActiveCategory($index)"
                  [class.text-[#2187AB]]="activeCategoryIndex() === $index"
                  class="block w-full text-left px-4 py-2 text-base hover:text-[#2187AB] transition-colors duration-200 cursor-pointer space-x-2"
                >
                  <span>
                    {{ category.name }}
                  </span>
                  @if (category.subGroups.length) {
                    <span class="float-end">&gt;</span>
                  }
                </a>
              </li>
            }
          </ul>
        </div>

        <!-- Right side with subcategories -->
        <div class="col-span-10 grow">
          @if (activeCategory(); as category) {
            <!--            [style.gridTemplateColumns]="-->
            <!--              'repeat(' + category.subGroups.length + ', 1fr)'-->
            <!--            "-->
            <div class="grid gap-6 grid-cols-3">
              @for (subGroup of category.subGroups; track subGroup.title) {
                <div>
                  <a
                    [routerLink]="['/categories', category.slug, subGroup.link]"
                    (click)="isMegaMenuOpen.set(false)"
                    class="font-semibold text-base mb-3 block hover:text-blue transition-colors cursor-pointer"
                  >
                    {{ subGroup.title }}
                  </a>
                  <ul class="space-y-2">
                    @for (item of subGroup.items; track item.slug) {
                      <li>
                        <a
                          [routerLink]="[
                            '/categories',
                            category.slug,
                            subGroup.link,
                            item.slug,
                          ]"
                          (click)="isMegaMenuOpen.set(false)"
                          class="text-base text-gray-600 hover:text-blue transition-colors"
                        >
                          {{ item.name }}
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
